import { action, makeObservable, observable } from "mobx";
export class PlayerBiometricRetriever {
    constructor(options) {
        this.processResponse = ({ player }) => {
            if (!player) {
                this.setCanonicalMetadata();
                return [];
            }
            this.setCanonicalMetadata({ playerName: `${player.firstName}-${player.lastName}`, playerId: player.playerId.toString() });
            this.data.push(player);
            return [player];
        };
        this.data = options.playerBiometricData ?
            observable.array([options.playerBiometricData.player]) :
            observable.array();
        this.connection = options.connection;
        this.setCanonicalMetadata = options.setCanonicalMetadata;
        makeObservable(this, {
            data: observable,
            processResponse: action,
            clearData: action
        });
    }
    activate() { }
    deactivate() {
        this.clearData();
    }
    loadData(playerId) {
        return this.connection
            .getData(playerId)
            .then(this.processResponse);
    }
    clearData() {
        this.data.splice(0);
        this.connection.cancel();
    }
}
//# sourceMappingURL=PlayerBiometricRetriever.js.map